import { render, staticRenderFns } from "./TraduccionPagina.vue?vue&type=template&id=3c7cf184&"
import script from "./TraduccionPagina.vue?vue&type=script&lang=ts&"
export * from "./TraduccionPagina.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports